document.addEventListener("DOMContentLoaded", function () {
    var ua = navigator.userAgent;

    var isiOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    var isMacOS = /Macintosh/.test(ua) && navigator.maxTouchPoints === 0;

    if (isiOS || isMacOS) {
        document.body.classList.add("ios-mac");
    }
});

document.addEventListener('DOMContentLoaded', function () {

    // Pause all videos in parent and reset controls
    function pauseAllVideos(parentElement) {
        var videos = parentElement.querySelectorAll('video');
        for (var i = 0; i < videos.length; i++) {
            videos[i].pause();
        }

        var controls = parentElement.querySelectorAll('[data-media-controls]');
        for (var j = 0; j < controls.length; j++) {
            var ctrl = controls[j];
            ctrl.querySelector('.controls__play').classList.remove('hide-control');
            ctrl.querySelector('.controls__pause').classList.add('hide-control');
        }
    }

    // Create video element
    function createVideoElement(videoSrc, videoMute) {
        var video = document.createElement('video');
        video.src = videoSrc;
        video.muted = videoMute;
        video.loop = true;
        video.playsInline = true;
        return video;
    }

    // Main click handler
    document.addEventListener('click', function (e) {
        var playButton = e.target.closest ? e.target.closest('.controls__play') : null;
        var pauseButton = e.target.closest ? e.target.closest('.controls__pause') : null;

        if (playButton) {
            var controls = playButton.closest('[data-media-controls]');
            var container = controls.parentElement;
            var picture = container.querySelector('picture');
            var video = container.querySelector('video');
            var videoSrc = controls.getAttribute('data-video');
            var videoMute = controls.hasAttribute('data-mute-video') ? true : false;

            if (!videoSrc) {
                console.error('No video source found');
                return;
            }

            // Pause other videos
            var swiper = container.closest('[data-swiper-main]');
            if (swiper) pauseAllVideos(swiper);

            // Create video if not exists
            if (!video) {
                video = createVideoElement(videoSrc, videoMute);
                container.appendChild(video);

                video.addEventListener('canplay', function () {
                    video.style.display = 'block';
                    // picture.style.display = 'none';
                    video.play();
                }, { once: true });

                video.addEventListener('error', function (err) {
                    console.error('Video failed to load:', err);
                    video.parentNode.removeChild(video);
                });

                video.load();
            } else {
                video.style.display = 'block';
                // picture.style.display = 'none';
                video.play();
            }

            playButton.classList.add('hide-control');
            controls.querySelector('.controls__pause').classList.remove('hide-control');
        }

        if (pauseButton) {
            var controls2 = pauseButton.closest('[data-media-controls]');
            var video2 = controls2.parentElement.querySelector('video');

            if (video2) {
                video2.pause();
                controls2.querySelector('.controls__play').classList.remove('hide-control');
                pauseButton.classList.add('hide-control');
            }
        }
    });

});
